<template>
    <el-dialog
        :title="editUserInfo ? '编辑管理员' : '创建管理员'"
        width="34%"
        :visible.sync="isShowDialog"
        @close="$emit('hide')">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="add-scheme-form">
            <el-form-item required label="用户名" prop="username">
                <el-input v-model="form.username" placeholder="请输入用户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" type="number" placeholder="请输入手机号，格式为数字" clearable></el-input>
            </el-form-item>
            <el-form-item required label="密码" prop="password">
                <el-input v-model="form.password" placeholder="请输入密码" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="isSubmitLoading" @click.stop="onCreate">{{ editUserInfo ? '修改' : '创建' }}</el-button>
                <el-button @click.stop="$emit('hide')">取消</el-button>
            </span>
    </el-dialog>
</template>

<script>
import api from '@/api/index.js'

export default {
    props: {
        isShowDialog: {
            type: Boolean,
            default: false
        },
        editUserInfo: {
            type: Object
        }
    },
    data () {
        return {
            isSubmitLoading: false,
            form: {
                account: '',
                phone: '',
                username: '',
                password: ''
            },
            rules: {}
        }
    },
    watch: {
        isShowDialog (value) {
            if (value) {
                if (this.editUserInfo) {
                    const { username, password, phone, account } = this.editUserInfo
                    this.form = {
                        username,
                        password,
                        phone
                    }
                } else {
                    // +new Date()
                    this.form = {
                        account: Math.random().toString(36).slice(-8),
                        phone: '',
                        username: '',
                        password: Math.random().toString(36).slice(-8)
                    }
                }
                
            }
        }
    },
    methods: {
        onCreate () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (!this.editUserInfo) {
                        this.createUser()
                    } else {
                        this.editUser()
                    }
                }
            })
        },
        createUser () {
            const userInfo = {
                ...this.form,
                userFolders: [
                    {
                        folderId:'111',
                        scope: '1'
                    }
                ]
            }
        },
        editUser () {
            try {
                const resp = api.editUser({
                    ...this.form
                })
                if (resp.success) {
                    this.$message.success('保存成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(resp.message)
            }
        }
    }
}
</script>

<style>

</style>